import { render, staticRenderFns } from "./ReviewsDashboard.vue?vue&type=template&id=3a6254fd&"
import script from "./ReviewsDashboard.vue?vue&type=script&lang=js&"
export * from "./ReviewsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsDashboard.vue?vue&type=style&index=0&id=3a6254fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports